var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DASFModuleRequest_1, DASFProgressReport_1;
import { JsonObject, JsonProperty, Any } from "./json2typescript/index.js";
export var MessageType;
(function (MessageType) {
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Info"] = "info";
    MessageType["ApiInfo"] = "api_info";
    MessageType["Request"] = "request";
    MessageType["Response"] = "response";
    MessageType["Log"] = "log";
    MessageType["Progress"] = "progress";
})(MessageType || (MessageType = {}));
export var PropertyKeys;
(function (PropertyKeys) {
    PropertyKeys["ResponseTopic"] = "response_topic";
    PropertyKeys["RequestContext"] = "requestContext";
    PropertyKeys["RequestMessageId"] = "requestMessageId";
    PropertyKeys["MessageType"] = "messageType";
})(PropertyKeys || (PropertyKeys = {}));
export var Status;
(function (Status) {
    Status["Success"] = "success";
    Status["Error"] = "error";
    Status["Running"] = "running";
})(Status || (Status = {}));
let DASFModuleRequest = DASFModuleRequest_1 = class DASFModuleRequest {
    constructor() {
        this.payload = "";
        this.context = "";
    }
    static createMessage(type) {
        const msg = new DASFModuleRequest_1();
        msg.properties = {};
        msg.properties[PropertyKeys.MessageType] = type;
        return msg;
    }
    static createRequestMessage() {
        return DASFModuleRequest_1.createMessage(MessageType.Request);
    }
    static createPingMessage() {
        return DASFModuleRequest_1.createMessage(MessageType.Ping);
    }
    static createPongMessage() {
        return DASFModuleRequest_1.createMessage(MessageType.Pong);
    }
    static createInfoMessage() {
        return DASFModuleRequest_1.createMessage(MessageType.Info);
    }
    static createApiInfoMessage() {
        return DASFModuleRequest_1.createMessage(MessageType.ApiInfo);
    }
    getMessageType() {
        if (this.properties) {
            return this.properties[PropertyKeys.MessageType];
        }
        throw new Error("Missing or empty message type property");
    }
};
__decorate([
    JsonProperty("payload", String)
], DASFModuleRequest.prototype, "payload", void 0);
__decorate([
    JsonProperty("properties", Any)
], DASFModuleRequest.prototype, "properties", void 0);
DASFModuleRequest = DASFModuleRequest_1 = __decorate([
    JsonObject("DASFModuleRequest")
], DASFModuleRequest);
export { DASFModuleRequest };
let DASFModuleRequestReceipt = class DASFModuleRequestReceipt {
    constructor() {
        this.result = "";
        this.messageId = "";
        this.errorMsg = "";
        this.context = "";
    }
    isOk() {
        return this.result == "ok";
    }
};
__decorate([
    JsonProperty("result", String)
], DASFModuleRequestReceipt.prototype, "result", void 0);
__decorate([
    JsonProperty("messageId", String, true)
], DASFModuleRequestReceipt.prototype, "messageId", void 0);
__decorate([
    JsonProperty("errorMsg", String, true)
], DASFModuleRequestReceipt.prototype, "errorMsg", void 0);
__decorate([
    JsonProperty("context", String, true)
], DASFModuleRequestReceipt.prototype, "context", void 0);
DASFModuleRequestReceipt = __decorate([
    JsonObject("DASFModuleRequestReceipt")
], DASFModuleRequestReceipt);
export { DASFModuleRequestReceipt };
let DASFAcknowledgment = class DASFAcknowledgment {
    constructor(messageId) {
        this.messageId = "";
        if (messageId) {
            this.messageId = messageId;
        }
    }
};
__decorate([
    JsonProperty("messageId", String)
], DASFAcknowledgment.prototype, "messageId", void 0);
DASFAcknowledgment = __decorate([
    JsonObject("DASFAcknowledgment")
], DASFAcknowledgment);
export { DASFAcknowledgment };
let DASFModuleResponse = class DASFModuleResponse {
    constructor() {
        this.messageId = "";
        this.payload = "";
        this.publishTime = "";
        this.properties = undefined;
    }
    getMessageType() {
        if (this.properties) {
            const msgType = this.properties[PropertyKeys.MessageType];
            if (msgType && msgType.trim().length > 0) {
                return msgType;
            }
        }
        throw new Error("Missing or empty message type property");
    }
    getRequestContext() {
        if (this.properties) {
            const context = this.properties[PropertyKeys.RequestContext];
            if (context) {
                return context;
            }
        }
        throw new Error("Missing or empty request context property");
    }
    getRequestMessageId() {
        if (this.properties) {
            const messageId = this.properties[PropertyKeys.RequestMessageId];
            if (messageId) {
                return messageId;
            }
        }
        throw new Error("Missing or empty request messageId property");
    }
    isFragmented() {
        return this.properties != undefined && this.properties.hasOwnProperty('num_fragments') && this.properties.hasOwnProperty('fragment');
    }
    getFragmentId() {
        if (this.properties && this.isFragmented()) {
            return this.properties['fragment'];
        }
        throw new Error('Unable to request fragment id from unfragmented response.');
    }
    getNumberOfFragments() {
        if (this.properties && this.isFragmented()) {
            return this.properties['num_fragments'];
        }
        throw new Error('Unable to request number of fragments from unfragmented response.');
    }
};
__decorate([
    JsonProperty("messageId", String)
], DASFModuleResponse.prototype, "messageId", void 0);
__decorate([
    JsonProperty("payload", String)
], DASFModuleResponse.prototype, "payload", void 0);
__decorate([
    JsonProperty("publishTime", String)
], DASFModuleResponse.prototype, "publishTime", void 0);
__decorate([
    JsonProperty("properties")
], DASFModuleResponse.prototype, "properties", void 0);
DASFModuleResponse = __decorate([
    JsonObject("DASFModuleResponse")
], DASFModuleResponse);
export { DASFModuleResponse };
let DASFProgressReport = DASFProgressReport_1 = class DASFProgressReport {
    constructor() {
        this.report_type = "";
        this.report_id = "";
        this.step_message = "";
        this.steps = 0;
        this.status = '';
        this.children = undefined;
    }
    hasError() {
        return this.status == Status.Error;
    }
    hasSuccess() {
        return this.status == Status.Success;
    }
    isRunning() {
        return this.status == Status.Running;
    }
    isComplete() {
        return !this.isRunning();
    }
};
__decorate([
    JsonProperty("report_type", String)
], DASFProgressReport.prototype, "report_type", void 0);
__decorate([
    JsonProperty("report_id", String)
], DASFProgressReport.prototype, "report_id", void 0);
__decorate([
    JsonProperty("step_message", String)
], DASFProgressReport.prototype, "step_message", void 0);
__decorate([
    JsonProperty("steps", Number)
], DASFProgressReport.prototype, "steps", void 0);
__decorate([
    JsonProperty("status", String)
], DASFProgressReport.prototype, "status", void 0);
__decorate([
    JsonProperty("children", [DASFProgressReport_1])
], DASFProgressReport.prototype, "children", void 0);
DASFProgressReport = DASFProgressReport_1 = __decorate([
    JsonObject("DASFProgressReport")
], DASFProgressReport);
export { DASFProgressReport };
//# sourceMappingURL=DASFMessages.js.map